export function isIphoneProduct(brand, name) {
  const b = String(brand || '').trim().toLowerCase();
  const n = String(name || '').trim().toLowerCase();
  return b === 'apple' || n.includes('iphone');
}

export function normalizeSerialInput(raw) {
  return String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
    .slice(0, 20);
}
